export default __webpack_public_path__ + "static/media/graylogo.fa6c67a4.svg";